export class EnvInfo {
  activeProfiles: string[] = [];
  get inProduction(): boolean {
    return this.activeProfiles && this.activeProfiles.includes('prod');
  }
}
